import { jsx as _jsx } from "react/jsx-runtime";
import { Fieldset } from '@base-ui/react/fieldset';
import { cn } from '../../../utils/utils';
// Groups several controls under one legend, which names the group for assistive tech.
// Use FieldRoot + FieldLabel instead when the label belongs to a single control.
export const FieldsetRoot = ({ className, ...props }) => {
    return (_jsx(Fieldset.Root, { ...props, className: cn('m-0 flex min-w-0 flex-col gap-1.5 border-0 p-0 font-roobert', className) }));
};
export const FieldsetLegend = ({ className, ...props }) => {
    return (_jsx(Fieldset.Legend, { ...props, className: cn('p-0 text-sm font-medium leading-5 text-neutral-900', className) }));
};
